import { Component } from '@angular/core';
import { BaseToolComponent } from '../base-tool.component';
import { ApplicationData } from 'src/app/data/application.data';
import { ModalService } from 'src/app/services/modal.service';

@Component({
  selector: 'tool-tip',
  templateUrl: './tool-tip.component.html',
  host: {
    class: 'tool-tip'
  }
})
export class ToolTipComponent extends BaseToolComponent {
  /**
	 * Constructor
	 */

   public tipRef:string;

  constructor(public applicationData:ApplicationData, public modalService:ModalService) {
    super();
    this.tipRef = "SHEETS.TIPS.tips_"+applicationData.configuration.sheetProperties.tipId;
  }

	/**
	 * On init
	 */
  ngOnInit() {

  }

  info() {
    this.modalService.open('modal-tip', {});
  }

	/**
	* On destroy
	*/
  ngOnDestroy() {

  }
}
